import { useEffect } from "react";
import { useI18n } from "../i18n";

const LOCALE = { ru: "ru_RU", cs: "cs_CZ", en: "en_US" };

function setMeta(selector, attr, value) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

/**
 * Keeps <title>, meta description, OG tags and <html lang> in sync with the
 * selected language — so Google indexes each language correctly and AI
 * assistants read accurate, localized content.
 */
export const SeoManager = () => {
  const { lang, t } = useI18n();

  useEffect(() => {
    const title = t("seo.title");
    const description = t("seo.description");

    document.title = title;
    document.documentElement.lang = lang;

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:locale"]', "content", LOCALE[lang] || "ru_RU");
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
  }, [lang, t]);

  return null;
};
